import React from 'react';
import PropTypes from 'prop-types';
import { BackorderedAlert } from '../../alerts/BackorderedAlert';

export const ApplianceShippingDetails = ({
  backordered = false
}) => {
  return (
    <>
      {backordered && <BackorderedAlert isMajorAppliance />}
    </>
  );
};

ApplianceShippingDetails.propTypes = {
  backordered: PropTypes.bool
};
